module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[68]67.13189b5.woff2";